/* assets/cart-recommendations.js
 *
 * Cart drawer recommendations (single-item Flickity carousel)
 * - Renders 1 item at a time
 * - Entire slide links to product
 * - Re-initialises after cart drawer updates
 * - No theme.js edits required
 */

(function () {
  'use strict';

  var DEBUG = false;
  function log() {
    if (!DEBUG) return;
    // eslint-disable-next-line no-console
    console.log.apply(console, arguments);
  }

  var SELECTORS = {
    drawer: 'cart-drawer',
    carousel: '#cart-recommendations-carousel',
    wrapper: '.cart-recommendations'
  };

  var STATE = {
    loading: false,
    lastKey: ''
  };

  function getCarouselEl() {
    return document.querySelector(SELECTORS.carousel);
  }

  function getWrapperEl(carouselEl) {
    if (!carouselEl) return null;
    return carouselEl.closest(SELECTORS.wrapper);
  }

  function formatMoneyFromCents(cents) {
    // Keep this available in case you later add price back in.
    try {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR'
      }).format((cents || 0) / 100);
    } catch (e) {
      return '';
    }
  }

  function uniqById(products) {
    var seen = {};
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p || !p.id) continue;
      if (seen[p.id]) continue;
      seen[p.id] = true;
      out.push(p);
    }
    return out;
  }

  function safeText(s) {
    if (s === null || s === undefined) return '';
    return String(s);
  }

  function escapeHtml(s) {
    return safeText(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildPriceHTML(product) {
    // Shopify product JSON prices are usually cents
    var price = Number(product && product.price ? product.price : 0);
    var compareAt = Number(product && product.compare_at_price ? product.compare_at_price : 0);
    var priceVaries = !!(product && product.price_varies);

    // Some themes prefer showing a range when price varies
    // Recommendations payload sometimes includes price_min / price_max. Use if present.
    var hasRange = priceVaries && product && product.price_min != null && product.price_max != null;
    var minPrice = hasRange ? Number(product.price_min) : null;
    var maxPrice = hasRange ? Number(product.price_max) : null;

    var moneyPrice = formatMoneyFromCents(price);
    var comparePrice = formatMoneyFromCents(compareAt);

    if (compareAt > price) {
      // On sale
      if (hasRange) {
        return (
          '' +
          '<div class="rec-price">' +
          '  <s class="pr_price regular">' + escapeHtml(comparePrice) + '</s>' +
          '  <span class="pr_price sale">' +
          escapeHtml(formatMoneyFromCents(minPrice)) + ' - ' + escapeHtml(formatMoneyFromCents(maxPrice)) +
          '  </span>' +
          '</div>'
        );
      }

      return (
        '' +
        '<div class="rec-price">' +
        '  <s class="pr_price regular">' + escapeHtml(comparePrice) + '</s>' +
        '  <span class="pr_price sale">' + escapeHtml(moneyPrice) + '</span>' +
        '</div>'
      );
    }

    // Not on sale
    if (hasRange) {
      return (
        '' +
        '<div class="rec-price">' +
        '  <span class="pr_price">' +
        escapeHtml(formatMoneyFromCents(minPrice)) + ' - ' + escapeHtml(formatMoneyFromCents(maxPrice)) +
        '  </span>' +
        '</div>'
      );
    }

    return (
      '' +
      '<div class="rec-price">' +
      '  <span class="pr_price">' + escapeHtml(moneyPrice) + '</span>' +
      '</div>'
    );
  }

  function buildSlidesHTML(products) {
    return products
      .map(function (product) {
        var img = product.featured_image || '';
        var title = product.title || '';
        var url = product.url || '#';

        // Ensure url starts with "/" if it is a relative path
        if (url && url.indexOf('/') !== 0 && url.indexOf('http') !== 0) {
          url = '/' + url;
        }

        var priceHtml = buildPriceHTML(product);

        return (
          '' +
          '<div class="recommendation-cell">' +
          '  <a href="' + escapeHtml(url) + '" class="recommendation-card-compact">' +
          '    <div class="rec-media">' +
          (img
            ? '      <img src="' +
              escapeHtml(img) +
              '" alt="' +
              escapeHtml(title) +
              '" loading="lazy">'
            : '') +
          '    </div>' +
          '    <div class="rec-meta">' +
          '      <div class="rec-title">' + escapeHtml(title) + '</div>' +
                 priceHtml +
          '    </div>' +
          '  </a>' +
          '</div>'
        );
      })
      .join('');
  }


  function destroyFlickity(el) {
    if (!el) return;
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flickity) return;
    var $el = window.jQuery(el);
    if ($el.data('flickity')) $el.flickity('destroy');
  }

  function initFlickity(el) {
    if (!el) return;
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flickity) {
      log('[Cart recs] Flickity not available yet');
      return;
    }

    var $el = window.jQuery(el);

    // Destroy any existing instance (important after drawer re-render)
    if ($el.data('flickity')) {
      $el.flickity('destroy');
    }

    $el.flickity({
      cellAlign: 'left',
      contain: true,
      groupCells: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      adaptiveHeight: true,
      draggable: true
    });
  }

  function setWrapperVisible(wrapperEl, visible) {
    if (!wrapperEl) return;
    wrapperEl.style.display = visible ? 'block' : 'none';
  }

  function keyForCart(cartJson) {
    try {
      // A stable key that changes if cart contents change
      var parts = (cartJson.items || []).map(function (it) {
        return it.product_id + ':' + it.quantity;
      });
      return parts.join('|') + '|count:' + (cartJson.item_count || 0);
    } catch (e) {
      return String(Date.now());
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function fetchRecsForProduct(productId, limit) {
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit || 4);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        return (data && data.products) ? data.products : [];
      })
      .catch(function (e) {
        log('[Cart recs] rec fetch error', e);
        return [];
      });
  }

  function loadCartRecommendations() {
    if (STATE.loading) return;

    var carouselEl = getCarouselEl();
    if (!carouselEl) {
      log('[Cart recs] carousel not found');
      return;
    }

    var wrapperEl = getWrapperEl(carouselEl);
    if (!wrapperEl) return;

STATE.loading = true;

// Keep hidden until we have products
        destroyFlickity(carouselEl);
        carouselEl.innerHTML = '';
        setWrapperVisible(wrapperEl, false);

    fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          setWrapperVisible(wrapperEl, false);
          destroyFlickity(carouselEl);
          STATE.loading = false;
          return;
        }

        var cartKey = keyForCart(cart);
        if (cartKey === STATE.lastKey) {
          // Cart unchanged. Still ensure Flickity is initialised after drawer renders.
          initFlickity(carouselEl);
          STATE.loading = false;
          return;
        }
        STATE.lastKey = cartKey;

        var cartProductIds = {};
        cart.items.forEach(function (item) {
          cartProductIds[item.product_id] = true;
        });

        // Fetch recs for each cart item sequentially (gentler on Shopify)
        var all = [];
        var chain = Promise.resolve();

        cart.items.forEach(function (item) {
          chain = chain.then(function () {
            return fetchRecsForProduct(item.product_id, 4).then(function (products) {
              for (var i = 0; i < products.length; i++) {
                var p = products[i];
                if (!p || !p.id) continue;
                if (cartProductIds[p.id]) continue; // do not recommend items already in cart
                all.push(p);
                if (all.length >= 8) break;
              }
            });
          });
        });

        return chain.then(function () {
          var products = uniqById(all).slice(0, 8);

          if (!products.length) {
            setWrapperVisible(wrapperEl, false);
            destroyFlickity(carouselEl);
            STATE.loading = false;
            return;
          }

            setWrapperVisible(wrapperEl, true);

            // Render slides
            destroyFlickity(carouselEl);
            carouselEl.innerHTML = buildSlidesHTML(products);

            var imgs = carouselEl.querySelectorAll('img');
                for (var i = 0; i < imgs.length; i++) {
                imgs[i].addEventListener('load', function () {
                    refreshFlickity(carouselEl);
                });
                }

            // Initialise after the element is visible and layout has a real width.
            // Two rAFs helps when parent layout is still updating.
            requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                initFlickity(carouselEl);
                refreshFlickity(carouselEl);

                // Drawer open animation can still be finishing, so refresh again shortly after.
                setTimeout(function () {
                refreshFlickity(carouselEl);
                }, 200);
            });
            });

            STATE.loading = false;

        });
      })
      .catch(function (e) {
        log('[Cart recs] error', e);
        // Fail silently in UI
        var wrapperEl2 = getWrapperEl(carouselEl);
        if (wrapperEl2) setWrapperVisible(wrapperEl2, false);
        STATE.loading = false;
      });
  }

  function refreshFlickity(el) {
  if (!el) return;
  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flickity) return;

  var $el = window.jQuery(el);
  if (!$el.data('flickity')) return;

  // Force Flickity to recalc sizes after the drawer animation/layout settles
  $el.flickity('resize');
  $el.flickity('reposition');
}

  // Run whenever the drawer becomes active or the drawer HTML is re-rendered
  function bindDrawerObserver() {
    var drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;

    // Watch for drawer opening (class active)
    try {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (drawer.classList.contains('active')) {
              log('[Cart recs] drawer active - loading recs');
              loadCartRecommendations();
            }
          }
        }
      });

      mo.observe(drawer, { attributes: true });
    } catch (e) {
      // ignore
    }

    // Also run once if already open
    if (drawer.classList.contains('active')) {
      loadCartRecommendations();
    }
  }

  // Listen for custom events if you later re-add them
  document.addEventListener('cart:drawer:open', function () {
    log('[Cart recs] cart:drawer:open heard');
    loadCartRecommendations();
  });

  // Run on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    bindDrawerObserver();
  })

  // If theme loads scripts late, also attempt once on full load
  window.addEventListener('load', function () {
    bindDrawerObserver();
  });

  // Expose a manual trigger for debugging
  window.cartRecommendations = window.cartRecommendations || {};
  window.cartRecommendations.reload = loadCartRecommendations;
})();
 